import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers';
import { removeStorage } from '@/libs/Storage';
import {  routerMode } from '@/config'
import { getAccessToken, removeAccessToken } from "@/libs/accessToken";


Vue.use(VueRouter);

// const originalPush = VueRouter.prototype.push;
const router = new VueRouter({
    routes,
    mode: routerMode,
})
router.beforeEach( (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    
    // 判断当前路由是否需要登录
    if(to.matched.some(item => item.meta.auth)){
        // 通过token值判断是否登录
        let token = getAccessToken();

        if(token && token != undefined){
            next();
        }else{
            var route = {
                name: 'login',
                query: {redirect: to.fullPath},
            }
            next(route);
            removeAccessToken();
            removeStorage('uuid');
            localStorage.clear();
        }
    }else{
         // 不需要身份校验 直接通过
         next();
    }
})

export default router;